<template>
    <section class="allergen-info">
        <h2 class="title">{{ $snippet('allergens', 'allergens') }}</h2>

        <div
            v-if="warning"
            class="warning"
            v-test:warning
        >
            <p class="warning-text">{{ warning }}</p>
        </div>

        <ingredients-contain
            v-if="contains || mayContain"
            :contains="contains"
            :may-contain="mayContain"
        />

        <nutrition-facts
            v-if="nutritionFacts.length"
            :facts="nutritionFacts"
        />
    </section>
</template>

<script>
    import IngredientsContain from '../../atoms/IngredientsContain/IngredientsContain';
    import NutritionFacts from '../../atoms/NutritionFacts/NutritionFacts';

    export default {
        name: 'allergen-info',

        components: { IngredientsContain, NutritionFacts },

        props: {
            contains: {
                type: String,
                default: '',
            },

            mayContain: {
                type: String,
                default: '',
            },

            warning: {
                type: String,
                default: '',
            },

            nutritionFacts: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .warning {
        margin-bottom: 24px;
        @include media-breakpoint-up(md) {
            margin-bottom: 16px;
        }
    }

    .app-icon {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        margin-right: 8px;
    }

    .warning-text {
        font-size: rem(14px);
        line-height: rem(18px);
        margin-bottom: 0;
        @include media-breakpoint-up(md) {
            font-size: rem(20px);
            line-height: rem(24px);
        }
    }

    .title {
        font-size: rem(24px);
        line-height: rem(28px);
        font-weight: 700;
        margin-bottom: 8px;
        @include media-breakpoint-up(md) {
            margin-bottom: 16px;
        }
    }

    .ingredients-contain {
        margin-bottom: 20px;
    }
</style>
